import { useAuthStep } from "@/hooks/useAuthStep";
import { useEffect } from "react";
import { trackEvent } from "@/lib/utils";
import { useCommunication } from "@/lib/CommunicationWrapper";

const ThankYou = () => {

    const { uuid, handleAuthFinish } = useAuthStep();

    const { closeModal, updateOptions } = useCommunication();

    const exitWithMenu = () => {
        handleAuthFinish();
        closeModal();
    }

    useEffect(() => {
        trackEvent("signup_thank_you_loaded", { "distinct_id": uuid });
    }, []);

    return (
        <div className="px-[30px] mb-[30px] flex flex-col justify-center align-center h-full h-full text-gray-500">
            <div className="flex-1 flex items-center justify-center">

                <div>
                    <img src={"/extlogo.png"} alt="logo" className="size-8" />
                    <h1 className="text-2xl font-medium text-black my-4 max-w-[66%]">Thank you for using BetterCampus 🥰</h1>
                    <button onClick={() => exitWithMenu()} style={{ background: "linear-gradient(90deg, #ffa952,#ff686c)"  }} className="mt-[20px] flex items-center justify-center gap-[8px] py-[12px] rounded-full w-full font-medium text-white shadow-[0_0_20px_#ff7e5299]">Start using BetterCampus!</button>
                </div>
            </div>
            <div className="flex flex-col justify-end">
                <p className="text-gray-500 text-xs">P.S. get a friend to join, our parents might finally stop asking about 'real jobs'.</p>
            </div>
        </div>
    )
}


export default ThankYou;
